import { createAction } from 'redux-actions'

const AUDIO_CHAT_START_REQUEST = 'AUDIO_CHAT_START_REQUEST'
const AUDIO_CHAT_START_REQUEST_CANCEL = 'AUDIO_CHAT_START_REQUEST_CANCEL'
const AUDIO_CHAT_RESET_PEER_STATUS = 'AUDIO_CHAT_RESET_PEER_STATUS'
const AUDIO_CHAT_START_RESPONSE = 'AUDIO_CHAT_START_RESPONSE'
const AUDIO_CHAT_STARTED = 'AUDIO_CHAT_STARTED'
const AUDIO_CHAT_END = 'AUDIO_CHAT_END'
const AUDIO_CHAT_MUTE_MICROPHONE = 'AUDIO_CHAT_MUTE_MICROPHONE'
const AUDIO_CHAT_PEER_MICROPHONE_MUTED = 'AUDIO_CHAT_PEER_MICROPHONE_MUTED'
const MEDIA_DEVICES_CONSTRAINTS_CHANGE = 'MEDIA_DEVICES_CONSTRAINTS_CHANGE'

const START_LISTEN_MEDIA_DEVICES_CHANGE = 'START_LISTEN_MEDIA_DEVICES_CHANGE'
const STOP_LISTEN_MEDIA_DEVICES_CHANGE = 'STOP_LISTEN_MEDIA_DEVICES_CHANGE'
const RESTART_CHAT_LISTEN_MEDIA_DEVICES_DONE = 'RESTART_CHAT_LISTEN_MEDIA_DEVICES_DONE'
const MEDIA_DEVICES_CHANGE = 'MEDIA_DEVICES_CHANGE'
const MEDIA_DEVICES_QUERY_IN_PROGRESS = 'MEDIA_DEVICES_QUERY_IN_PROGRESS'
const SELECT_AUDIO_INPUT = 'SELECT_AUDIO_INPUT'
const SILENCE_AUDIO = 'SILENCE_AUDIO'
const BUILD_SILENCE_AUDIO = 'BUILD_SILENCE_AUDIO'

export const audioChatStartRequest = createAction(AUDIO_CHAT_START_REQUEST)
export const audioChatStartRequestCancel = createAction(AUDIO_CHAT_START_REQUEST_CANCEL)
export const audioChatResetPeerStatus = createAction(AUDIO_CHAT_RESET_PEER_STATUS)
export const audioChatStartResponse = createAction(AUDIO_CHAT_START_RESPONSE)
export const audioChatStarted = createAction(AUDIO_CHAT_STARTED)
export const audioChatEnd = createAction(AUDIO_CHAT_END)
export const audioChatMuteMicrophone = createAction(AUDIO_CHAT_MUTE_MICROPHONE)
export const audioChatPeerMicrophoneMuted = createAction(AUDIO_CHAT_PEER_MICROPHONE_MUTED)

// called on chat request, either by you or peer
// retrievs the microphone and listen for audio devices change
export const startListenMediaDevicesChange = createAction(START_LISTEN_MEDIA_DEVICES_CHANGE)

// called on chat request cancel / reject / end, either by you or peer
// stops the microphone track and stop listening for audio devices change
export const stopListenMediaDevicesChange = createAction(STOP_LISTEN_MEDIA_DEVICES_CHANGE)

// start listen media devices is automatically on reconnect if chat was active;
// on listen media devices completion, restartChatListenMediaDevicesDone action should be dispatched
export const restartChatListenMediaDevicesDone = createAction(RESTART_CHAT_LISTEN_MEDIA_DEVICES_DONE)

// send the input media devices to store
export const mediaDevicesChange = createAction(MEDIA_DEVICES_CHANGE)
export const mediaDevicesConstraintsChange = createAction(MEDIA_DEVICES_CONSTRAINTS_CHANGE)

// navigator.getUserMedia() start/end flag
export const mediaDevicesQueryInProgress = createAction(MEDIA_DEVICES_QUERY_IN_PROGRESS)
// navigator.getUserMedia() call timeout to display a message
// if the call duration > timeout it means that the browser popup asking for permission
// is displayed and the user have to answer
export const QUERY_MEDIA_DEVICES_TIMEOUT = 1500

// send current microphone data to store
export const selectAudioInput = createAction(SELECT_AUDIO_INPUT)
// the silence audio track that replaces the microphone track
// on webrtc.audioTransceiver.sender
export const silenceAudio = createAction(SILENCE_AUDIO)
export const buildSilenceAudio = createAction(BUILD_SILENCE_AUDIO)

const AUDIO_CHAT_STATS_REQUEST = 'AUDIO_CHAT_STATS_REQUEST'
const AUDIO_CHAT_STATS_RESPONSE = 'AUDIO_CHAT_STATS_RESPONSE'
const AUDIO_CHAT_STATS = 'AUDIO_CHAT_STATS'

export const audioChatStatsRequest = createAction(AUDIO_CHAT_STATS_REQUEST)
export const audioChatStatsResponse = createAction(AUDIO_CHAT_STATS_RESPONSE)
export const audioChatStats = createAction(AUDIO_CHAT_STATS)
export const SPEAKING_MIN_AUDIO_LEVEL = 0.01
